const uIFormTriggerOperatorType = {
    EQUALS : 0,

    CONTAINS : 1,

    MATCHES : 2,

    GREATER : 3,

    GREATEREQUAL : 4,

    LESS : 5,

    LESSEQUALS : 6

};

angular.module('gw-um-j2js')
    .constant('uIFormTriggerOperatorType', uIFormTriggerOperatorType);